import React from 'react';

export const useToggleBoolean = (
  defaultValue: boolean
): [boolean, () => void, (x: boolean) => void] => {
  const [open, toggleOpen] = React.useState(defaultValue);
  const toggleBoolean = (): void => toggleOpen((prevState) => !prevState);
  return [open, toggleBoolean, toggleOpen];
};
